import { useEffect, useState } from 'react';

const useExtractRoute = (url: string) => {
  const [route, setRoute] = useState('');

  useEffect(() => {
    const extractRoute = (url: string) => {
      try {
        const sanitizedUrl = url.replace(/\[|\]/g, '');
        const parsedUrl = new URL(sanitizedUrl);
        
        const pathname = parsedUrl.pathname;
        const routeWithoutDomain = pathname.startsWith('/') ? pathname.slice(1) : pathname;
        const finalRoute=routeWithoutDomain.split('/').slice(1).join('/').replace(/%7B/g, '{').replace(/%7D/g, '}');
        return `/${finalRoute}`;
      } catch (error) {
        console.error('Invalid URL:', error);
        return '';
      }
    };

    const route = extractRoute(url);
    setRoute(route);
  }, [url]);

  return route;
};

export default useExtractRoute;